import styled from 'styled-components';
import { ModalPopoverUnderlay } from '@beamery/lib-ds-components';
import { maxFormWidth } from 'candidate-facing-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.backgrounds.onGray};
  border-radius: ${({ theme }) => theme.radii.x2};
  max-height: 100%;
  width: 100%;
  max-width: ${({ theme }) =>
    `calc(${maxFormWidth} + ${theme.space.x4} + ${theme.space.x4})`};

  & > [data-overlay-container] {
    max-height: 100%;
    min-height: 0;
    display: flex;
  }
`;

export const PopoverUnderlay = styled(ModalPopoverUnderlay as typeof Content)`
  box-sizing: border-box;
  & * {
    box-sizing: border-box;
  }
`;
